import React from 'react';
import PropTypes from 'prop-types';
import GridRadioButton from 'components/form/GridRadioButton';
import GridRadioGroup from 'components/form/GridRadioGroup';
import { sortBusinessPartners } from './useBusinessPartners';

//! choix du partenaire de souscription : on garde le comportement historique (valeur = nom du partenaire
//! en minuscule, ex. "cardif") pour rester compatible avec les données déjà enregistrées en base
const BusinessPartnerSubscriptionField = ({ name, businessPartners }) => (
    <GridRadioGroup name={name} className="quintuple double per-subscription">
        <GridRadioButton label="Aucun" value="" />
        {sortBusinessPartners(businessPartners).map(([id, { name: partnerName, isActive }]) => (
            <GridRadioButton key={id} label={partnerName} value={partnerName.toLowerCase()} disabled={!isActive} />
        ))}
    </GridRadioGroup>
);

BusinessPartnerSubscriptionField.propTypes = {
    name: PropTypes.string.isRequired,
    businessPartners: PropTypes.shape({}).isRequired,
};

export default BusinessPartnerSubscriptionField;
